import Seo from "../components/common/seo/Seo";
import Benefits from "../components/home/Benefits";
import Header from "../components/home/header/Header";
import Hero from "../components/home/Hero";
import LinkYourStoreBanner from "../components/home/LinkYourStoreBanner";
import Contact from "../components/home/contact/Contact";
import Footer from "../components/home/footer/Footer";
import LinkYourStore from "../components/home/LinkYourStore";
import WhyChooseUs from "../components/home/WhyChooseUs";
import AOS from "aos";
import "aos/dist/aos.css";
import { lazy, useEffect } from "react";
import PriceBanner from "../components/home/PriceBanner";
import WebExample from "../components/home/WebExample";
import TagManager from "react-gtm-module";
import PromoBanner from "../components/home/banners/PromoBanner";
import CarouselBanners from "../components/home/CarouselBanners";
import WhatsApp from "../components/home/WhatsApp";

// const FeatureSectionImage = lazy(() => import("../components/home/FeatureSectionImage"))

const Home = () => {
 useEffect(() => {
  AOS.init({ duration: 1000 });
  AOS.refresh();
 }, []);
 const handleButtonClick = (category, action, label) => {
  TagManager.dataLayer({
   dataLayer: {
    event: category,
    category: category,
    action: action,
    label: label,
   },
  });
 };

 return (
  <div className="main-page-wrapper">
   {/* <WhatsApp /> */}
   {/* <Seo title="Power Bizz" /> */}
   {/* <Sidebar /> */}
   <Header />
   <CarouselBanners />
   <Benefits />
   {/* <PromoBanner /> */}
   <PriceBanner handleButtonClick={handleButtonClick} />
   <WhyChooseUs handleButtonClick={handleButtonClick} />
   <LinkYourStore handleButtonClick={handleButtonClick} />
   <LinkYourStoreBanner />
   <WebExample />
   <Contact />
   <Footer />
  </div>
 );
};

export default Home;
